module.exports = __webpack_public_path__ + "static/media/bookmarkDemo.fbd5283b.mp4";